<template>
<div>
  <!-- ROLE -->
  <!-- LIST POPULATED FROM ROLE RESOURCE -->
  <b-form-group class="form_input_margin">
    <i class="fas fa-user-cog"></i> Role: <br/>
    <ejs-dropdownlist id='dropdownlist' placeholder='Select a role'
        :dataSource='userRoleList' :fields="userRoleFields" :v-model="user['role.name']"
        :value="selectDropDownItemForUpdate('dropdownlist', user['role.name'], userRoleList)"
        @change="user.role = setDropDownItemValue('dropdownlist', userRoleList);"

    ></ejs-dropdownlist>
    <div v-if="$v.user.role.$dirty">
      <div v-if="!$v.user.role.required" class="error">Field is required</div>
    </div>
  </b-form-group>

  <!--EMAIL-->
  <b-form-group :class="{ 'form-group--error': $v.user.email.$error }">
    <mdb-input id="email" v-model.trim="$v.user.email.$model" icon="envelope" label="Your email" type="email"/>
    <div v-if="$v.user.email.$dirty">
      <div v-if="!$v.user.email.required" class="error">Field is required</div>
      <div v-if="!$v.user.email.email" class="error">Email mismatch. Example johndoe123@icipe.org</div>
    </div>
  </b-form-group>
</div>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import {getUserRoles, selectDropDownItemForUpdate, setDropDownItemValue} from "@/utils/util_functions";
import EventBus from "@/components/EventBus";
import {mdbInput} from "mdbvue";

export default {
  name: "UserEmailRoleComponent", components: {mdbInput},
  data() {
    return{
      userRoleList: [], userRoleFields: {}
    }
  },

  props: {
    user: {
      required: true,
    }
  },

  validations: {
    user: { email: {required, email}, role: {required}}
  },

  mounted() {
    EventBus.$on('get-user-roles', payload=> {
      this.userRoleList = payload['items']
      this.userRoleFields = payload['fields']


      if (!this.user.hasOwnProperty('role.name'))
        this.user['role.name'] = selectDropDownItemForUpdate('dropdownlist', this.user.role,  this.userRoleList);
    })
  },

  methods: {
    selectDropDownItemForUpdate, setDropDownItemValue,
  },
  created() { getUserRoles() }
}
</script>
